import styled from 'styled-components'
import clock from 'assets/svgs/clock.svg'

export const WrapperSelectOptions = styled.div`
  width: 100%;

  .mono-select__dropdown-indicator {
    background: url(${clock}) no-repeat scroll;
    background-position: right 7px top 5px;
    cursor: pointer;

    svg {
      visibility: hidden;
    }
  }
`

export const TimePickerWrapper = styled.div`
  flex: 1;
  min-width: 95px;
  position: relative;

  && .mono-select__control {
	    height: 60px;
	    min-height: 60px;
	    width: 95%;
	}

  /* ドロップダウンメニューの表示設定 */
  && .mono-select__menu-portal {
	    z-index: 9999;
	}

  && .mono-select__menu {
	    position: absolute;
	    top: 100%;
	    left: 0;
	    right: 0;
	    z-index: 9999;
	    width: max-content;
	    min-width: 100%;
	    background: white;
	    border: 1px solid #ccc;
	    border-radius: 4px;
	    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
	}

  /* メニューの最大高さとスクロール設定 */
  && .mono-select__menu-list {
	    max-height: 200px;
	    overflow-y: auto;
	    scroll-behavior: auto;
	    /* ドロップダウン内スクロールが親に影響しないように */
	    overscroll-behavior: contain;
  }

  /* スクロール時の親への影響を完全に防ぐ */
  .mono-select__menu-list::-webkit-scrollbar {
    width: 6px;
  }

  .mono-select__menu-list::-webkit-scrollbar-track {
    background: #f1f1f1;
  }

  .mono-select__menu-list::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 3px;
  }

  /* フォーカス時の自動スクロール防止 */
  .mono-select__control:focus,
  .mono-select__control:focus-within {
    scroll-behavior: auto;
  }
`
